const { getAxiosInstance } = require('../connection');

module.exports = {
    favoriteSession: function (sessionId, favorited) {
        return getAxiosInstance({
            method: favorited ? 'POST' : 'DELETE',
            url: ['favorite_program', !favorited ? encodeURIComponent(sessionId) : null].filter(Boolean).join('/'),
            data: {
                program_id: sessionId,
            },
        }).then((response) => response.data);
    },
};
